import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { AuthService } from "../../../services/auth.service";
import { NbThemeService } from "@nebular/theme";

@Component({
  selector: "ngx-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = "";

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  logged: boolean = false;
  rememberMe = false;
  returnUrl: string;

  loginMicrosoft() {
    this.authService.login();
  }

  constructor(
    public authService: AuthService,
    public activatedRoute: ActivatedRoute,
    private themeService: NbThemeService,
    protected cd: ChangeDetectorRef,
    protected router: Router
  ) {
    this.themeService.changeTheme("dark");
    this.activatedRoute.queryParams.subscribe((params) => {
      if (!this.returnUrl) {
      }
    });
    this.logged = this.authService.getToken() ? true : false;
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    document.getElementById("nb-global-spinner").style.display = "none";
  }
}
